export default __webpack_public_path__ + "static/media/balanceWarning.293f026f.png";